import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Admin Components
import AdminDashboard from '../pages/admin/Dashboard';
import AdminUser from '../pages/admin/Users';
import Sessions from '../pages/admin/Sessions';
import Payments from '../pages/admin/Payments';
import AdminAudit from '../pages/admin/AuditLogs';
import Reports from '../pages/admin/Reports';
import AdminSettings from '../pages/admin/Settings';
import Layout from '../pages/admin/Layout';


// Coming Soon Component
import ComingSoon from '../components/ComingSoon';

const AdminRoutes = () => {
  return (
    <Layout>
    <Routes>
      
      {/* Admin Routes */}
      <Route path="/" element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="users" element={<AdminUser />} />
      <Route path="users/:isOpenTraining" element={<AdminUser />} />
      <Route path="sessions" element={<Sessions />} />
      <Route path="payments" element={<Payments />} />
      <Route path="audit-logs" element={<AdminAudit />} />
      <Route path="reports" element={<Reports />} />
      <Route path="settings" element={<AdminSettings />} />
      <Route path="*" element={<ComingSoon 
        title="Coming Soon"
        subtitle="Nurse feature under development"
        description="This nurse feature is currently being developed. Please check back soon for updates!"
      />} />     
    </Routes>
    </Layout>
  );
};

export default AdminRoutes;
